<script>
    import LangSelector from "./LangSelector.svelte";
    export let links = [];
    export let active = false;
    export let onSelect = () => {};
</script>

<style>
    .menu {
        position: fixed;
        top: -100%;
        background-color: white;
        padding: 1em 1.6em 1em 1.6em;
        z-index: 9999;
        transition: all 0.3s;
    }

    a {
        color: black;
    }

    .active {
        top: 4em;
    }
</style>

<div class="menu shadow-drop-bl d-lg-none col-12 { active ? 'active' : ''}">
    {#each links as link}
        <p><a on:click={onSelect} href={link.href}>{link.text}</a></p>
    {/each}
    <div>
        <LangSelector languages={[{text:'Italiano',lang:'it'},{text:'English',lang:'en'}]}/>
    </div>
</div>